import getConfig from 'next/config';

export const ignoreErrors = [
  /^No error$/,
  /__show__deepen/,
  /_avast_submit/,
  /Access is denied/,
  /anonymous function: captureException/,
  /Blocked a frame with origin/,
  /console is not defined/,
  /cordova/,
  /DataCloneError/,
  /Error: AccessDeny/,
  /event is not defined/,
  /feedConf/,
  /myGloFrameList/,
  /SecurityError/,
  /MyIPhoneApp/,
  /snapchat.com/,
  /vid_mate_check is not defined/,
  /win\.document\.body/,
  /window\._sharedData\.entry_data/,
  /ztePageScrollModule/,
  /Network request failed/,
  /Failed to fetch/,
  /NetworkError/,
  /Network Error/,
  /_pcmBridgeCallbackHandler/,
  /_handleMessageFromToutiao/,
  /Error no especificado/,
  /ibFindAllVideos/,
  /ibPauseAllVideos/,
  /timeout of 0ms exceeded/,
];

const { publicRuntimeConfig } = getConfig() || { publicRuntimeConfig: {} };

const realNodeEnv = publicRuntimeConfig.NODE_ENV || process.env.NODE_ENV;

export const SENTRY_DSN = process.env.SENTRY_DSN || publicRuntimeConfig.NEXT_PUBLIC_SENTRY_DSN;

export const { SENTRY_ENVIRONMENT, SENTRY_RELEASE } = publicRuntimeConfig;

export const SENTRY_ENABLED = realNodeEnv === 'production' || realNodeEnv === 'staging';
